export type SpeciesOption = {
  speciesId: string;
  label: string;
  profileId: string;
  baseWalkSpeed?: number;
  choices?: {
    readonly elf?: {
      readonly lineages: readonly {
        readonly id: string;
        readonly label: string;
        readonly description: string;
      }[];
      readonly keenSenses: {
        readonly profileId: string;
        readonly field: string;
        readonly count: number;
        readonly pool: readonly string[];
      };
      readonly spellcastingAbilities: readonly {
        readonly id: string;
        readonly label: string;
      }[];
    };
    readonly dragonborn?: {
      readonly ancestries: readonly {
        readonly id: string;
        readonly label: string;
        readonly damageType: string;
        readonly description: string;
      }[];
    };
    readonly tiefling?: {
      readonly legacies: readonly {
        readonly id: string;
        readonly label: string;
        readonly description: string;
      }[];
      readonly spellcastingAbilities: readonly {
        readonly id: string;
        readonly label: string;
      }[];
      readonly sizes: readonly {
        readonly id: string;
        readonly label: string;
      }[];
    };
  };
  traits?: readonly {
    readonly label: string;
    readonly description: string;
  }[];
};

export async function fetchSpecies(): Promise<SpeciesOption[]> {
  const res = await fetch("/api/species");
  if (!res.ok) {
    throw new Error("Failed to fetch species");
  }
  return res.json() as Promise<SpeciesOption[]>;
}
